// extracted by mini-css-extract-plugin
module.exports = {"button":"_2QteB","hiddenLabel":"_2_4v7"};